module.exports = __webpack_public_path__ + "img/arrow-right.bd468974.svg";